$(document).ready(function () {
    $('#mass-facturation-button').on('click', function(e){
        e.preventDefault();
        $('#mass_facturation').val('1');
        $('#advanced_search_form_facturation').trigger('submit');
    })

    $('#billableModal').on('show.bs.modal', function (e) {
        //$("input[name='no_billing']")[0].focus();
        let infos = e.relatedTarget.id.split('-');
        let id = infos[1];
        let line = infos[2];
        if (infos[0] == 'recepBillable')
            $('form[name="billable-form"]').attr('action', route('billing.recepValidate', {'id' : id, 'line': line}));
        else
        {
            if (line)
                $('form[name="billable-form"]').attr('action', route('billing.partialValidate', {'id' : id, 'line': line}));
            else
                $('form[name="billable-form"]').attr('action', route('billing.validate', id));
        }

        $(this).find('#provisional_price').val(e.relatedTarget.dataset.price);
        $(this).find('#billing_price').attr('max', e.relatedTarget.dataset.price);
    });

    // Datepicker
    jQuery.datetimepicker.setLocale('fr');
    $('.billing_date').datetimepicker({
        timepicker:false,
        locale: 'fr',
        dayOfWeekStart: 1,
        format: 'd/m/Y',
    });

    $('.billable_fournisseurModal').on('show.bs.modal', function (e) {
        // Ajout du prix prévisionnel de la facture

        // Récupération du parent
        let parent = $(this).parent();

        // Récupération de tous les prix avec les checkbox checked
        let priceProvisional = 0;
        parent.find('input:checked').each(function() {
            priceProvisional = parseFloat(priceProvisional) + parseFloat($(this).data('price'));
        });
        parent.find('#provisional_price').val(priceProvisional.toFixed(5));
        parent.find('#billing_price').attr('max', (priceProvisional + 1).toFixed(5));
    });

    $('.js_billing-price').on('input', function(e){
        let parent = $(this).parent().parent();
        // Modification de la valeur
        let currentGap = $(this).val() - parent.find('#provisional_price').val();
        let billing_gap = parent.find('#billing_gap');
        billing_gap.val(currentGap.toFixed(5));
        if(currentGap.toFixed(5) != 0)
            billing_gap.addClass('text-danger');
        else
            billing_gap.removeClass('text-danger');
    })

    // Ecouteur sur les modification d'une valeur de facturation
    $('.line-billing-price').on('input', function(e){
        updateCommandLines($(this))
        updateSummaryDocument($(this))
    })

    // Ecouteur sur les modification d'une valeur de facturation
    $('.lines-ckb').on('input', function(e){
        updateCommandLines($(this))
        updateSummaryDocument($(this))
    })

    // Ecouteur sur l'ajout d'un nouveau document
    $('.bill-new-document').on('click', function(e){
        // Récupération des premières variables
        let parentGrouper = $(this).parents('.documents-grouper')
        let tableBodyGrouper = parentGrouper.find('.documents-grouper--body')
        // Requête Ajax
        $.ajax({
            url: route('billing.addDocument'),
            type: 'GET',
        }).done(function(data){
            tableBodyGrouper.append(data)
            $('.billing_date').datetimepicker({
                timepicker:false,
                locale: 'fr',
                dayOfWeekStart: 1,
                format: 'd/m/Y',
            });
        }).fail(function(){
            // Do nothing
        })
    })

    $(document).on('click', '.btn-delete-ligne', function(e){
        if(confirm('Êtes-vous sûr de vouloir supprimer ce document ?')){
            $(this).parents('tr').remove()
            updateSummaryDocument($(this))
        }
    })

    $('.selectAllBillingLines').on('click', toggleBillingQuantity)
    $('.selectGloballyBillingLines').on('click', toggleGlobalBillingQuantity)

    // $(document).on('input', '.document-amount', updateSummaryDocument)
    $(document).on('input', '.document-amount', function(){
        updateSummaryDocument($(this))
    })

    $('.checkAllBillingLines').on('click', function(){
        let parent = $(this).parents('.commande-wrapper')
        if ($(this).data('filled') == 'off')
        {
            parent.find('.lines-ckb').each(function(index, element) {
                $(element).prop('checked', true).trigger('input')
            });
            $(this).text('Annuler').data('filled', 'on');
        }
        else
        {
            parent.find('.lines-ckb').each(function(index, element) {
                $(element).prop('checked', false).trigger('input')
            });
            $(this).text('Tout cocher').data('filled', 'off');
        }
        updateSummaryDocument($(this))
    })

    $('.checkGloballyBillingLines').on('click', function(){
        let parent = $(this).parents('form')
        if ($(this).data('filled') == 'off')
        {
            parent.find('.lines-ckb').each(function(index, element) {
                $(element).prop('checked', true).trigger('input')
            });
            $(this).text('Tout décocher globalement').data('filled', 'on');
        }
        else
        {
            parent.find('.lines-ckb').each(function(index, element) {
                $(element).prop('checked', false).trigger('input')
            });
            $(this).text('Tout cocher globalement').data('filled', 'off');
        }
        updateSummaryDocument($(this))
    })
});

/**
 * Function permettant de remplir tous les champs de réception automatiquement par leur valeur max
 */
function toggleBillingQuantity() {
    let parent = $(this).parents('.commande-wrapper')
    if ($(this).data('filled') == 'off')
    {
        parent.find('.line-billing-price').each(function(index, element) {
            $(element).val($(element).data('price')).trigger('input')
        });
        $(this).text('Annuler').data('filled', 'on');
    }
    else
    {
        parent.find('.line-billing-price').each(function(index, element) {
            $(element).val(0).trigger('input')
        });
        $(this).text('Tout remplir').data('filled', 'off');
    }
    updateSummaryDocument($(this))
}

/**
 * Fonction permettant de "check" toutes les cases à cocher de toutes les commande
 */
function toggleGlobalBillingQuantity(){
    let parentForm = $(this).parents('form')
    if ($(this).data('filled') == 'off')
    {
        parentForm.find('.line-billing-price').each(function(index, element) {
            $(element).val($(element).data('price')).trigger('input')
        });

        $(this).text('Tout déremplir globalement').data('filled', 'on');
    }
    else
    {
        parentForm.find('.line-billing-price').each(function(index, element) {
            $(element).val(0).trigger('input')
        });
        $(this).text('Remplir globalement').data('filled', 'off');
    }
    updateSummaryDocument($(this))
}

function updateCommandLines(originElement){
    let parent = originElement.parents('.commande-wrapper')
    // Récupération du parent
    let parentForm = parent.find('.dtb-billing-form')
    let commandLines = parent.find('.ligne_commandes')
    // Récupération de la somme
    let totalCurrentBilling = 0;
    let totalProvisionnalBilling = 0;
    commandLines.each(function(index, element){
        let billingCkb = $(element).find('.lines-ckb')
        if(billingCkb.is(":checked")){
            let billingInput = $(element).find('.line-billing-price')
            totalCurrentBilling += Number(billingInput.val())
            totalProvisionnalBilling += Number(billingInput.data('price'))
        }
    })
    // Affichage du billing GAP
    let provisionnalBillingPrice = parentForm.find('.provisionnal-billing-price');
    provisionnalBillingPrice.val(Number(totalProvisionnalBilling).toFixed(5))
    let filledBillingPrice = parentForm.find('.filled-billing-price');
    filledBillingPrice.val(Number(totalCurrentBilling).toFixed(5))

    // Si prix facturé supérieur alors texte en rouge pour avertissement
    if(filledBillingPrice.val() > provisionnalBillingPrice.val()){
        filledBillingPrice.addClass('text-warning').removeClass('text-success')
    }
    else{
        filledBillingPrice.addClass('text-success').removeClass('text-warning')
    }
}

/**
 * Fonction de calcul permettant de mettre à jour les prix
 */
function updateSummaryDocument(originElement){
    // Récupération du parent afin de chercher les fils
    let parent = originElement.parents('form')
    // Récupération dans le champs footer d'une commande
    let initialPrice = 0;
    let goalPrice = 0;
    parent.find('.provisionnal-billing-price').each(function(idx, elem) {
        // console.log($(elem).val())
        initialPrice += parseFloat($(elem).val());
    })
    parent.find('.filled-billing-price').each(function(idx, elem) {
        // console.log($(elem).val())
        goalPrice += parseFloat($(elem).val());
    })
    // Récupération des champs des documents pour remplir les données
    let filledDocumentInput = parent.find('.document-filled-billing-price')
    let gapProvisionalDocumentInput = parent.find('.document-billing-gap')
    let provisionalDocumentInput = parent.find('.document-provisional-billing-price')
    let gapInitialDocumentInput = parent.find('.document-initial-billing-gap')
    let initialDocumentInput = parent.find('.document-initial-billing-price')

    // Récupération de la somme
    let totalCurrentBilling = 0;
    parent.find('.documents-grouper--body .document-amount').each(function(index, element){
        totalCurrentBilling += Number($(element).val())
    })
    gapBilling = totalCurrentBilling - goalPrice;
    gapInitialBilling = totalCurrentBilling - initialPrice;

    // Mise en place des valeurs
    filledDocumentInput.val(Number(totalCurrentBilling).toFixed(5)).data('price', goalPrice)
    provisionalDocumentInput.val(Number(goalPrice).toFixed(5))
    gapProvisionalDocumentInput.val(Number(gapBilling).toFixed(5))
    initialDocumentInput.val(Number(initialPrice).toFixed(5))
    gapInitialDocumentInput.val(Number(gapInitialBilling).toFixed(5))

    // Si prix facturé supérieur alors texte en rouge pour avertissement
    if(filledDocumentInput.val() > provisionalDocumentInput.val()){
        gapProvisionalDocumentInput.addClass('text-danger')
    }
    else{
        gapProvisionalDocumentInput.removeClass('text-danger')
    }
    if(filledDocumentInput.val() > initialDocumentInput.val()){
        gapInitialDocumentInput.addClass('text-danger')
    }
    else{
        gapInitialDocumentInput.removeClass('text-danger')
    }
}
